import { APIGATEWAY_BASE_URL } from 'src/dataLayer/env';
import makeAjaxRequest from '../makeAjaxRequest';

export const ERROR_KEYS = {
  422: {
    key: 'captcha.error.invalid_format'
  },
  401: {
    key: 'captcha.error.expired_token'
  },
  400: {
    key: 'common.error.unknown'
  },
  default: {
    key: 'common.error.unknown'
  }
};

export default () =>
  makeAjaxRequest({
    verb: 'GET',
    url: `${APIGATEWAY_BASE_URL}/v1/captcha/password-reset`,
    errorKeys: ERROR_KEYS
  }).then((response) => {
    const captchaConfig = { provider: response.provider, siteKey: response.site_key };
    return captchaConfig;
  });
